import { ColumnDef, DataGrid } from "@arelia-components/ui-atoms/data-grid";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Card, CardContent, CardHeader } from "@mui/material";
import { useMemo } from "react";
import { PublishingRoyaltyDetail } from "../models";
import { formatDate } from "@arelia-utils/helpers/dates";

export type Props = {
  data: PublishingRoyaltyDetail[] | undefined;
  isLoading: boolean;
};

export default function RoyaltiesDetailsTablePresenter({ data = [], isLoading }: Props) {
  const columns: ColumnDef[] = useMemo(() => [
    { field: "reportedOn", headerName: "Reported On", formatter: ({ value }) => formatDate(value, "QQQ yyyy") },
    { field: "earnedOn", headerName: "Earned On" },
    { field: "songTitle", headerName: "Song" },
    { field: "source", headerName: "Source" },
    { field: "territory", headerName: "Territory" },
    { field: "type", headerName: "Type" },
    { field: "typeGroup", headerName: "Type Group" },
    { field: "amountReceived", headerName: "Amount Received", type: "currency" },
    { field: "rate", headerName: "Rate", formatter: ({ value }) => value ? `${value}%` : '' },
    { field: "amountEarned", headerName: "Amount Earned", type: "currency" },
  ], []);

  return (
    <Card>
      <CardHeader title="Royalties Details"/>
      <CardContent sx={styles.cardContent}>
        <SpinnerWrapper loading={isLoading}>
          <DataGrid rows={data} columns={columns} rowsPerPage={[20, 50, 100]} sx={styles.table}/>
        </SpinnerWrapper>
      </CardContent>
    </Card>
  );
}

const styles = {
  cardContent: {
    height: "calc(100% - 54px)"
  },
  table: {
    height: "50vh",
    paddingRight: "8px"
  }
};